export default __webpack_public_path__ + "static/media/015-travelling.d3bb4be5.svg";